export default __webpack_public_path__ + "static/media/field-background.3106e7f5.png";